import * as React from 'react';

import type {
  GridColumnVisibilityModel,
  GridSlotProps,
} from '@mui/x-data-grid';
import {
  gridColumnVisibilityModelSelector,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid';

import { GridColumnsManagement } from '../grid-columns-management';

function GridColumnsManagementDefault(
  props: GridSlotProps['columnsManagement'],
) {
  const apiRef = useGridApiContext();

  const columnVisibilityModel = useGridSelector(
    apiRef,
    gridColumnVisibilityModelSelector,
  );

  // MUI default function
  const toggleColumn = (event: React.MouseEvent<HTMLButtonElement>) => {
    const { name: field } = event.target as HTMLInputElement;

    apiRef.current.setColumnVisibility(
      field,
      columnVisibilityModel[field] === false,
    );
  };

  // MUI default logic
  const onColumnVisibilityChange = React.useCallback(
    (model: GridColumnVisibilityModel) =>
      apiRef.current.setColumnVisibilityModel(model),
    [apiRef],
  );

  return (
    <GridColumnsManagement
      {...props}
      columnVisibility={columnVisibilityModel}
      onColumnVisibilityChange={onColumnVisibilityChange}
      toggleColumn={toggleColumn}
    />
  );
}

export { GridColumnsManagementDefault };
